import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { SimpleButtonProps } from '~/types/global';
import { SimpleButtonSizes, SIMPLE_BUTTON_TYPES } from '~/constants/global';

function SimpleButton({
  type,
  size = SimpleButtonSizes.md,
  onClick,
  className = '',
  hideIcon = false,
  ...props
}: SimpleButtonProps) {
  const buttonConfig = SIMPLE_BUTTON_TYPES[type];

  const buttonClasses = clsx(
    'inline-block',
    buttonConfig.color,
    className,
    size === SimpleButtonSizes.sm && 'text-sm',
    size === SimpleButtonSizes.lg && 'text-lg',
    size === SimpleButtonSizes.md && 'text-base',
  );

  return (
    <button {...props} className={buttonClasses} onClick={onClick}>
      {!hideIcon && (
        <FontAwesomeIcon icon={buttonConfig.icon} className="mr-2" />
      )}
      {buttonConfig.text}
    </button>
  );
}

export default SimpleButton;
